module.exports = __webpack_public_path__ + "49f2b1cad420fd2531eca7c2ffa70d33.MP3";